import { NgModule } from "@angular/core";
import { OnboardingPanelCardComponent } from "./onboarding-panel-card.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  exports: [OnboardingPanelCardComponent],
  declarations: [OnboardingPanelCardComponent],
})
export class OnboardingPanelCardModule {}
